import { cn } from 'utils/classMerge'

import type { Step } from './index'

interface StepIndicatorProps {
  step: Step
  animated?: boolean
}

const getStepLabel = (status: Step['status']): string =>
  ({
    complete: 'Complete',
    current: 'Current',
    upcoming: 'Upcoming',
  }[status])

export const StepIndicator = ({
  step,
  animated = true,
}: StepIndicatorProps) => {
  const isComplete = step.status === 'complete'
  const isCurrent = step.status === 'current'

  return (
    <div
      className={cn('tw-block tw-h-2.5 tw-w-2.5 tw-rounded-full', {
        'tw-bg-orange-500': isComplete || isCurrent,
        'tw-bg-zinc-200': !isComplete && !isCurrent,
        'tw-relative': isCurrent && animated,
        'after:tw-absolute after:tw-left-[-2px] after:tw-top-[-2px] after:tw-h-3.5 after:tw-w-3.5 after:tw-rounded-full after:tw-bg-orange-500/30 after:tw-animate-ping':
          isCurrent && animated,
      })}
      data-testid={`step-indicator-${step.status}`}
    >
      <span className="tw-sr-only">{getStepLabel(step.status)}</span>
    </div>
  )
}
